import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { amplitudeModule } from '@/modules/amplitude';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PageStyles,
  PageTitleStyles,
  PageSubtitleStyles,
  BottomButtonStyles,
  OverlayStyles,
} from './WelcomeScreen.styles';

export const WelcomeScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'WelcomeScreen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles>
      <IonContent>
        <OverlayStyles />
        <div className="content-wrapper">
          <LogoWithAppName className="app-logo" withCaption={false} />
          <PageTitleStyles
            className="page-title"
            component="h1"
            variant="headline-large"
            align="center"
          >
            Explore your desires with
            <br />
            <UiTypography
              variant="inherit"
              color="secondary-static"
              component="span"
              className="page-subtitle"
            >
              stunning trans women
            </UiTypography>
            <PageSubtitleStyles>
              Flirt, chat, and connect in a safe space.
            </PageSubtitleStyles>
          </PageTitleStyles>
          <BottomButtonStyles
            size="large"
            round="md"
            onClick={handleNextStep}
            expand="full"
          >
            I’m ready to meet her
          </BottomButtonStyles>
        </div>
      </IonContent>
    </PageStyles>
  );
};
